import React, { HTMLAttributes } from 'react'

import PageSubtitle from '@/components/typography/PageSubtitle'
import { Heading } from '@/components/ui/heading'
import { cn } from '@/lib/utils'

type Props = HTMLAttributes<HTMLHeadingElement> & {
  subtitle?: React.ReactNode
  size?: 'lg' | 'md'
  icon?: React.ReactNode
  wrapperProps?: Omit<React.ComponentProps<'header'>, 'children'>
  subtitleProps?: Omit<React.ComponentProps<typeof PageSubtitle>, 'children'>
}

const PageTitle: React.FC<Props> = ({
  children,
  className,
  subtitle,
  size = 'lg',
  icon,
  wrapperProps,
  subtitleProps,
  ...props
}) => (
  <header
    className={cn('flex flex-col gap-1 mb-4', wrapperProps?.className)}
    {...wrapperProps}
  >
    <div className="flex items-center gap-2">
      {icon}

      <Heading
        size={1}
        className={cn(
          'mb-0 font-semibold text-foreground',
          size === 'lg' ? 'text-[20px]' : 'text-base',
          className,
        )}
        {...props}
      >
        {children}
      </Heading>
    </div>
    {subtitle && <PageSubtitle {...subtitleProps}>{subtitle}</PageSubtitle>}
  </header>
)

export default PageTitle
